import { Injectable, NgZone } from '@angular/core';
import { getRandomId, inIframe } from '@asamco/utils';
import { merge, Subject, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import Swal, { SweetAlertOptions } from 'sweetalert2';

import { IFrameChildService } from '../iframe/i-frame-child.service';
import { IFrameCommService } from '../iframe/i-frame-comm.service';
import { IFrameParentService } from '../iframe/i-frame-parent.service';
import { MessageType } from '../iframe/message-type.enum';
import { Message } from '../iframe/message.interface';

/**
 * Sweetalert service
 */
@Injectable({
	providedIn: 'root',
})
export class AsSwalService {
	/** Subject for the subscription on the iframe communication service */
	private commUnsubscribe: Subscription;

	private map = new Map();

	/**
	 * Constructor
	 */
	constructor(private comm: IFrameCommService, private childService: IFrameChildService, private zone: NgZone) {
		this.init();
	}

	/**
	 * Initialization
	 */
	private init() {
		this.commUnsubscribe = merge(this.comm.incomingMessages$)
			.pipe(filter((msg: Message) => msg.type === MessageType.swal))
			.subscribe(m => this.zone.run(() => this.alert(m)));
	}

	/**
	 * wrapper around SWAL to allow dialoag to be initialized from the inner app.
	 */
	alert(msg) {
		const { options, actionId } = msg.payload;
		Swal.fire(options).then(
			result =>
				this.comm.send({
					type: MessageType.swal,
					payload: { actionId, result },
				}),
			rejectionReason =>
				this.comm.send({
					type: MessageType.swal,
					payload: { actionId, rejectionReason },
				})
		);
	}
	modalOpen() {
		document.body.classList.add('modal-open');
		return this.send({
			action: 'modalOpen',
			payload: true,
		});
	}

	modalClose() {
		document.body.classList.remove('modal-open');
		return this.send({
			action: 'modalClose',
			payload: false,
		});
	}

	fire<T>(options: SweetAlertOptions): Promise<any> {
		if (inIframe()) {
			this.modalOpen();
			return Swal.fire<T>(options).finally(() => {
				this.modalClose();
			});
		} else {
			return Swal.fire<T>(options);
		}
	}

	send(payload) {
		const actionId = getRandomId();
		if (payload.action === undefined) {
			throw new Error(`you can't call the sideMenu without an action`);
		}
		payload.actionId = actionId;
		const subject = new Subject<any>();
		this.map.set(actionId, subject);
		this.childService.send({ type: MessageType.sideMenu, payload });
		return subject.toPromise();
	}

	isLoading() {
		return Swal.isLoading();
	}

	showValidationMessage(validationMessage: string) {
		return Swal.showValidationMessage(validationMessage);
	}
}
